import Vue from 'vue';
import validator from './validator'; 
export default {
  // 妈的写这么多方法，多传个参数不就可以了，最后一个方法就够了
    // 数量
     qty(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))
        let d=validatorData.qty
        let num=Number(row.qty)
        row.qty= num.toFixed(d)
      },
    //   重量
      wgt(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))
        let d=validatorData.wgt
        let num=Number(row.wgt)
        row.wgt= num.toFixed(d)
  },
      // 数量
     oldqty(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))
        let d=validatorData.qty
        let num=Number(row.oldqty)
        row.oldqty= num.toFixed(d)
      },
    //   重量
      oldwgt(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))
        let d=validatorData.wgt
        let num=Number(row.oldwgt)
        row.oldwgt= num.toFixed(d)
      },
    //   毛重
      gross_wgt(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))

        let d=validatorData.wgt
        let num=Number(row.gross_wgt)
        row.gross_wgt= num.toFixed(d)
      },
    //   价格
      amt(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))
        let d=validatorData.amt
        let num=Number(row.amt)
        row.amt= num.toFixed(d)
  },
      //   价格
      oldamt(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))
        let d=validatorData.amt
        let num=Number(row.oldamt)
        row.oldamt= num.toFixed(d)
      },
    //   附加工费
      add_wage(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))

        let d=validatorData.amt
        let num=Number(row.add_wage)
        row.add_wage= num.toFixed(d)
  },
      //   附加工费（件）
      add_qtywage(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))

        let d=validatorData.amt
        let num=Number(row.add_qtywage)
        row.add_qtywage= num.toFixed(d)
  },
      //   附加工费(重)
      add_wgtwage(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))

        let d=validatorData.amt
        let num=Number(row.add_wgtwage)
        row.add_wgtwage= num.toFixed(d)
      },
    //   重工费
      wgt_prc(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))

        let d=validatorData.amt
        let num=Number(row.wgt_prc)
        row.wgt_prc= num.toFixed(d)
      },
      //   数单价
      qty_prc(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))

        let d=validatorData.amt
        let num=Number(row.qty_prc)
        row.qty_prc= num.toFixed(d)
      },
    //   税率
      rate(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))

        let d=validatorData.rate
        let num=Number(row.rate)
        row.rate= num.toFixed(d)
      },
     //来料成色
     alloy(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))

        let d=validatorData.rate
        let num=Number(row.alloy)
        row.alloy= num.toFixed(d)
      },
    //   折扣
      discount(row){
        let validatorData=JSON.parse(sessionStorage.getItem('validatorData'))
        let d=validatorData.rate
        let num=Number(row.discount)
        row.discount= num.toFixed(d)
  },
      //合并
      all(row,rate,type){
        let validatorData = JSON.parse(sessionStorage.getItem('validatorData'))
        let d = validatorData[rate]
        
        let num=Number(row[type])
        row[type]= num.toFixed(d)
  }
}
